import { AUTH_ROUTES } from '../../constants/_routes'
import auth_types from '../../constants/authTypes'
import {axios, reset_axios} from '../../services'

// import { reset_preferences } from '../preferencesActions'

const try_force_logoff = ( response ) => {
  if (response !== undefined && response.force_logoff === true ) {
    return {
      type: auth_types.LOGOUT.force
    }
  }
  return {
    type: "DUMMY"
  }
}

const clear_state = () => {
  return {
    type: "CLEAR_APP_STATE"
  }
}

const logout_request = () => {
  return {
    type: auth_types.LOGOUT.request
  }
}

const logout_success = () => {
  return {
    type: auth_types.LOGOUT.success
  }
}

const logout_failure = (messages) => {
  return {
    type: auth_types.LOGOUT.failure,
    payload: messages
  }
}

const destroy_user_storage = () => {
  localStorage.removeItem('userdata')
  reset_axios()
}

const logoutUser = () => {
  return function (dispatch ) {
    // REQUEST
    dispatch(logout_request())

    axios(
      {
        url: AUTH_ROUTES.logout,
        method: 'DELETE'
      }
    ).then( response => {
      // SUCCESS
      destroy_user_storage(  )
      dispatch( logout_success( ) )
      dispatch( clear_state( ) )
      // dispatch( reset_preferences() )
    }).catch( error => {
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Logout failed."]
      }
      // FAILURE
      dispatch( logout_failure( errors ) )
    })
  }

}

export {
  logoutUser,
  try_force_logoff
 }



// WEBPACK FOOTER //
// ./src/js/actions/auth/logout.js